/* ------------------------------------------------------------------ */
/*                            External Dependencies                           */
/* ------------------------------------------------------------------ */
import React, { useState } from "react"
// import { Helmet } from "react-helmet"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
/* ------------------------- Internal Dependencies ------------------------ */
import apple from "../img/apple.svg"
import audiomack from "../img/audiomack.svg"
import spotify from "../img/spotify.svg"
import PreviewCompatibleImage from "../components/PreviewCompatibleImage"
import ContactCard from "../components/ContactCard"
import SEO from "../components/SEO"
const propTypes = {
  artist: PropTypes.shape({
    title: PropTypes.string.isRequired,
    image: PropTypes.object.isRequired,
    email: PropTypes.string,
    phone: PropTypes.number,
    twitter: PropTypes.string,
    facebook: PropTypes.string,
    instagram: PropTypes.string,
    spotify: PropTypes.string,
    audiomack: PropTypes.string,
    itunes: PropTypes.string,
    description: PropTypes.string.isRequired,
  }),
  helmet: PropTypes.object,
}
export const ArtistPostTemplate = ({ artist, helmet }) => {
  const [card, showCard] = useState(false)
  const handleShowCard = () => {
    showCard(!card)
  }
  return (
    <section className="max-w-screen-xl px-5 py-20 mx-auto overflow-y-hidden static">
      {helmet || ""}
      {
        card && (
          <ContactCard
            showCard={handleShowCard}
            name={artist.title}
            twitter={artist.twitter}
            instagram={artist.instagram}
            phone={artist.phone}
            email={artist.email}
          />
        )
      }
      <div className="grid md:grid-cols-2 grid-cols-1 md:gap-16 gap-5 py-10 ">
        <div>
          {
            artist.image &&
              <PreviewCompatibleImage
                imageInfo={{
                  image: artist.image,
                  alt: artist.title,
                }}
              />
          }
        </div>
        <div>
          <h2 className="font-medium text-yellow-300 text-3xl mb-5">
            {artist.title}
          </h2>
          <p className="text-base text-white mb-5 leading-8">{artist.description}</p>
          <div className="md:flex block justify-between mb-5">
            <div className="md:w-2/5">
              <p className="text-yellow-300 text-base font-medium">
                Social Media Handles
              </p>
              <div className=" flex">
                <a
                  href={`http://instagram.com/${artist.instagram}`}
                  className="m-2 ml-0"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <svg
                    className="w-5"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.2235 1.67334L5.85674 1.67334C3.54631 1.67334 1.67334 3.54631 1.67334 5.85674L1.67334 14.2235C1.67334 16.534 3.54631 18.4069 5.85674 18.4069L14.2235 18.4069C16.534 18.4069 18.4069 16.534 18.4069 14.2235L18.4069 5.85674C18.4069 3.54631 16.534 1.67334 14.2235 1.67334Z"
                      stroke="#ffffff"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.387 9.51304C13.4902 10.2094 13.3713 10.9205 13.0471 11.5453C12.7229 12.1702 12.2099 12.6769 11.5811 12.9934C10.9523 13.3098 10.2398 13.42 9.54477 13.3082C8.84977 13.1963 8.20773 12.8682 7.70997 12.3704C7.21221 11.8727 6.88408 11.2306 6.77224 10.5356C6.66041 9.84065 6.77057 9.12808 7.08705 8.4993C7.40354 7.87052 7.91023 7.35754 8.53506 7.03332C9.15989 6.70911 9.87105 6.59017 10.5674 6.69343C11.2776 6.79876 11.9352 7.12973 12.4429 7.63746C12.9507 8.14519 13.2817 8.80276 13.387 9.51304Z"
                      stroke="#ffffff"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.6418 5.43848H14.6502"
                      stroke="#ffffff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>
                <a
                  href={`http://twitter.com/etrecordslabel/${artist.twitter}`}
                  className="m-2"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <svg
                    className="w-5"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.2036 2.51012C19.4024 3.07528 18.5153 3.50754 17.5764 3.79024C17.0725 3.21085 16.4028 2.80019 15.6579 2.61381C14.913 2.42743 14.1289 2.47431 13.4115 2.74812C12.6941 3.02193 12.0781 3.50945 11.6469 4.14476C11.2156 4.78006 10.9898 5.53249 11.0001 6.30028V7.13696C9.52976 7.17509 8.0728 6.84899 6.75899 6.1877C5.44518 5.52642 4.3153 4.55048 3.46999 3.3468C3.46999 3.3468 0.123271 10.8769 7.65339 14.2236C5.93027 15.3933 3.87759 15.9798 1.79663 15.897C9.32675 20.0804 18.5302 15.897 18.5302 6.27518C18.5295 6.04213 18.5071 5.80965 18.4633 5.58074C19.3172 4.73861 19.9198 3.67538 20.2036 2.51012V2.51012Z" stroke="#ffffff"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>
                <a
                  href={`https://facebook.com/${artist.facebook}`}
                  className="m-2"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <svg
                    className="w-5"
                    viewBox="0 0 21 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.9798 1.67334L13.4698 1.67334C12.3603 1.67334 11.2962 2.11409 10.5117 2.89863C9.72716 3.68317 9.28641 4.74723 9.28641 5.85674V8.36678H6.77637L6.77637 11.7135H9.28641L9.28641 18.4069H12.6331L12.6331 11.7135H15.1432L15.9798 8.36678L12.6331 8.36678V5.85674C12.6331 5.63484 12.7213 5.42203 12.8782 5.26512C13.0351 5.10821 13.2479 5.02006 13.4698 5.02006L15.9798 5.02006V1.67334Z"
                      stroke="#ffffff"
                      strokeWidth="1"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <div className="md:w-3/5 flex justify-start mt-3">
              <button
                className="text-white border-white rounded-md border px-5 py-2"
                onClick={handleShowCard}
              >
                Contact Artist
              </button>
            </div>
          </div>
          <div>
            <p className="text-yellow-300 text-base font-medium">
              Streaming Platforms
            </p>
            <div className="flex">
              <a
                href={`https://www.spotify.com/${artist.spotify}`}
                className="m-2 text-gray-300 text-sm flex "
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src={spotify} alt="Spotify logo" />
                <span className="ml-1">Spotify</span>
              </a>
              <a
                href={`https://audiomack.com/${artist.audiomack}`}
                className="m-2 text-gray-300 text-sm flex "
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src={audiomack} alt="Audiomack Logo" />
                <span className="ml-1">Audiomack</span>
              </a>
              <a
                href={artist.itunes}
                className="m-2 text-gray-300 text-sm flex "
                rel="noopener noreferrer"
                target="_blank"
              >
                <img src={apple} alt="itunes Logo" />
                <span className="ml-1">itunes</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
ArtistPostTemplate.propTypes = propTypes

const ArtistPost = ({ data }) => {
  const { markdownRemark: artist } = data

  return (
    <>
      <ArtistPostTemplate
        artist={artist.frontmatter}
        description={artist.frontmatter.description}
      />
      <SEO title={artist.frontmatter.title} description={artist.frontmatter.description} url={artist.slug} />
    </>
  )
}
ArtistPost.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
}

export default ArtistPost
export const pageQuery = graphql`
  query ArtistPostByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        title
        description
        title
        image  {
          childImageSharp {
            fluid(maxWidth: 600, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
          }
        email
        phone
        twitter
        facebook
        instagram
        spotify
        audiomack
        itunes
        description
      }
    }
  }
`
